import { GlEmptyState, GlModal, GlSprintf } from '@gitlab/ui';
export default {
    name: 'WorkItemTicketModal',
    components: {
        GlEmptyState,
        GlModal,
        GlSprintf
    },
    emits: [
        'hide'
    ]
};
